import axios from '../../axios/axios';

// const BASE_URL = 'http://localhost:8080/api/payments';

const PaymentHistoryService = {
  getPaymentsByClientOnExcursionId: (clientOnExcursionId) => {
    return axios.get(`payments/client-on-excursion/${clientOnExcursionId}`);
  },

  addPayment: (paymentData) => {
    return axios.post(`payments/add`, paymentData);
  },

  updatePayment: (id, paymentData) => {
    return axios.post(`payments/update/${id}`, paymentData);
  },

  deletePayment: (id) => {
    return axios.delete(`payments/delete/${id}`);
  },
  // updatePricePaid: (clientOnExcursionId, priceChange) => {
  //   return axios.post(`payments/updatePricePaid/${clientOnExcursionId}`, { priceChange });
  // }
};

export default PaymentHistoryService;